import React from 'react';

import CMSPage from '../CMSPage/CMSPage';

const HOME_PAGE_ID = 'home';

/** Render the Console Pages home asset at the marketplace root. */
export const LandingPageComponent = props => (
  <CMSPage {...props} pageId={HOME_PAGE_ID} currentPage="LandingPage" schemaType="WebPage" />
);

export default LandingPageComponent;
